import React, { useState } from "react";
import { ReactComponent as MailIcon } from "../../../Assets/Icons/mailIcon.svg";
import { ReactComponent as PhoneIcon } from "../../../Assets/Icons/phoneIcon.svg";
import { ReactComponent as Clock } from "../../../Assets/Icons/Clock.svg";
import { ReactComponent as MapIcon } from "../../../Assets/Icons/MapIcon.svg";
import { ReactComponent as DeleteIcon } from "../../../Assets/Icons/deleteIcon.svg";
import { ReactComponent as EditIcon } from "../../../Assets/Icons/editSvg.svg";
import "../../common/OfferList/offerList.scss";

const PopupContent = ({ storeDetails, handleDeleteClick, handleEditClick }) => {
  if (!storeDetails) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[400px]">
        <div className="loader"></div>
        <p className="mt-4 text-[#767676] font-poppins text-[15px]">Loading store details...</p>
      </div>
    );
  }

  const { _id, name, email, googlePlaceId, merchant, phone, tradingHours } =
    storeDetails;

  const capitalize = (word) => word.charAt(0).toUpperCase() + word.slice(1);

  return (
    <div
      style={{ scrollbarWidth: "none" }}
      className="max-h-[500px] overflow-y-auto w-full flex flex-col gap-2 justify-between font-poppins"
    >
      <div className="w-full flex justify-between items-center mb-4 gap-10">
        <h1 className="font-[600] text-[20px] md:text-[22px] lg:text-[24px]">
          {merchant?.businessName}
        </h1>
        <div className="flex justify-between items-center gap-4">
          <DeleteIcon
            className="cursor-pointer"
            onClick={() => handleDeleteClick(storeDetails)}
          />
          <EditIcon
            className="cursor-pointer"
            onClick={() => handleEditClick(_id)}
          />
        </div>
      </div>
      <div className="flex gap-2 items-start">
        <MapIcon className="shrink-0 mt-1" />
        <h3 className="break-words w-full text-[14px] md:text-[16px] leading-tight">{googlePlaceId?.address}</h3>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-4 my-2">
        <div className="flex gap-2 mt-1 items-center">
          <MailIcon className="shrink-0" />
          <p className="text-[14px] font-[400] text-[#767676] break-all">{email}</p>
        </div>
        <div className="flex justify-start items-center gap-2 mt-1 text-[14px] font-[400] text-[#767676]">
          <PhoneIcon className="shrink-0" />
          <p>{phone}</p>
        </div>
      </div>
      <div className="flex gap-2">
        <Clock />
        <div className="w-full flex flex-col justify-start items-start gap-2 text-[14px] font-[400] text-[#767676]">
          <p>Trading Hours</p>
          <div className="w-full md:w-[70%] flex flex-col gap-2 mt-4">
            {tradingHours?.map(({ day, openTime, closeTime, _id }) => (
              <div
                key={_id}
                className="flex justify-between items-center w-full mb-2"
              >
                <span className="text-[13px] md:text-[14px]" style={{ fontWeight: 500 }}>{capitalize(day)}</span>
                <span className="text-[13px] md:text-[14px]">{`${openTime} - ${closeTime}`}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PopupContent;
